import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import { env } from '~/constants/env';

import { resources } from './resources';

export const initTranslations = () => {
  i18n.use(initReactI18next).init({
    resources,
    lng: 'nl',
    fallbackLng: env.IS_LOCAL_DEV_ENV ? ['nl', 'dev'] : 'nl',
    interpolation: {
      escapeValue: false,
    },
    react: {
      transWrapTextNodes: 'span',
    },
  });

  i18n.services.formatter?.add('ucfirst', (value) =>
    typeof value === 'string' ? `${value.charAt(0).toUpperCase()}${value.slice(1)}` : value,
  );
};
